import React, { useState } from 'react';
import SlimHero from '../ui/hero/hero-slim';
import Team from '../ui/team/team';
import mockTeam from '../mocks/team.json';

export default () => {
  const pageTitle = "Our Team";
  const [team, setTeam] = useState(mockTeam[0]);

  return <>
    <SlimHero title="Our Team at NRNA Australia" />
    <div className="row">
      <div className="flex-col">
        <Team team={team}/>
      </div>
    </div>
  </>
}
